import { render, staticRenderFns } from "./ConfirmApplications.vue?vue&type=template&id=0d606158&"
import script from "./ConfirmApplications.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ConfirmApplications.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports